import * as React from 'react';
import { AEMContent, Card, Heading } from '@mlc/web-ui-toolkit';

const Introduction: React.FunctionComponent = () => (
	<Card marginBottom={8}>
		<Heading el="h2" fontSize="regular" marginBottom={6}>
			Your Client Data Exchange account
		</Heading>
		<AEMContent path="/secure/_content/Adviser/epi/client-data-exchange" />
	</Card>
);

export default Introduction;
